import React from 'react';
import { Tabs, Toast } from 'antd-mobile';
import { Input, Divider, Popconfirm, Form, Table, Button } from 'antd';
import { onGet, onPost, api } from '../../core/api3';
import { getUrlParam } from '../../utils/commonUtils';
import 'antd-mobile/dist/antd-mobile.css';

class EatMobileView extends React.Component {

    constructor() {
        super();
        this.state = {
            eat: {}
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        document.title = '加菜的艺术';
        this.loadData();
    }

    loadData() {
        onGet(api.listEat.url).then(response => {
            if (response === undefined) {
                return;
            }
            this.setState({ eat: response });
        });
    }

    onClick(type, key) {
        switch (type) {
            default:
                break;
        }
    }

    getEat(type) {
        switch(type) {
            case 'breakfast':
                // return (
                    
                // );
                break;
            default:
                break;
        }
    }

    render() {
        const tabs = [
            { title: '早餐' },
            { title: '午餐' },
            { title: '下午茶' },
            { title: '晚餐' }
        ];
        return (
            <div style={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                <Tabs tabs={tabs} initialPage={0} swipeable={true}>
                    <div className="content2">
                        <Form>
                            <Form.Item style={{ marginBottom: 0 }}>
                                实盘名称：{this.state.eat.breakfast}
                            </Form.Item>
                        </Form>
                    </div>
                </Tabs>
            </div>
        );
    }

}

const EatMobilePage = Form.create()(EatMobileView);
export default EatMobilePage;


// WEBPACK FOOTER //
// ./src/page/mobile/EatMobilePage.jsx